let menu = () => {
  let menu = $('#mainMenu')
  let menuM = $('#mainMenuTable')
  
  let menuArr = []
  let menuArrM = []
  
  let menuUp = menu.find('.menuTitle li')
  let menuMid = menu.find('.menuWithPic .wonderfulAspect')
  let menuDown = menu.find('.wonderfulPic .imgBorder')
  
  let menuUpM = menuM.find('.menuTitle li')
  let menuMidM = menuM.find('.menuWithPic .wonderfulAspect')
  let menuDownM = menuM.find('.wonderfulPic .imgBorder')
  
  ;[...menuUp].map(value => menuArr.push(value))
  ;[...menuMid].map(value => menuArr.push(value))
  ;[...menuDown].map(value => menuArr.push(value))
  
  ;[...menuUpM].map(value => menuArrM.push(value))
  ;[...menuMidM].map(value => menuArrM.push(value))
  ;[...menuDownM].map(value => menuArrM.push(value))
  
  menuArrM.map(value => {
    value.addEventListener('click', ev => {
      let that = ev.currentTarget
      
      menuArrM.map(val => val.classList.remove('active'))
      
      that.classList.add('active')
    })
  })
  
  menuArr.map(value => {
    value.addEventListener('click', ev => {
      let that = ev.currentTarget
      
      menuArr.map(val => val.classList.remove('active'))
      
      that.classList.add('active')
    })
  })
  
  //  监听定位
  $(window).on('G2_onLeave', ev => {
    let index = ev.nextIndex - 1
    menuDown.removeClass('active')
    menuMid.removeClass('active')
    menuUp.removeClass('active')
    
    menuDownM.removeClass('active')
    menuMidM.removeClass('active')
    menuUpM.removeClass('active')
    
    if ($('#page-5')) {
      if (index < 3) {
        menuUp.eq(index).addClass('active')
        menuUpM.eq(index).addClass('active')
      } else if (index < 6) {
        menuMid.eq(index - 3).addClass('active')
        menuMidM.eq(index - 3).addClass('active')
      } else if (index < 7) {
        menuDown.addClass('active')
        menuDownM.addClass('active')
      }
    } else {
      if (index < 3) {
        menuUp.eq(index).addClass('active')
        menuUpM.eq(index).addClass('active')
      } else if (index < 5) {
        menuMid.eq(index - 3).addClass('active')
        menuMidM.eq(index - 3).addClass('active')
      } else if (index < 6) {
        menuDown.addClass('active')
        menuDownM.addClass('active')
      }
    }
    
  })
  
}

//  三个侧框
let sideNavF = () => {
  //  移动端导航
  let inD = 400
  let outD = 450
  let direction2 = window.gp2_is_rtl == true ? 'left' : 'right'
  $('#sideMenu').sideNav({
    edge: direction2,
    closeOnClick: true,
    duration: inD,
    durationO: outD,
    onOpen: () => {
      $('#nav-icon').addClass('open')
      $('#legalNotices').sideNav('hide')
    },
    onClose: () => {
      $('#nav-icon').removeClass('open')
    }
  })
  /* !! BUG !!
    处理移动端Menu 打开时 切换为PC端时的BUG
    @author - Buff
    @date   - 3/5/2018
    @time   - 9:31 PM
  */
  $(window).resize(() => {
    if (window.innerWidth > window.gp_max_md) {
      $('#sideMenu').sideNav('hide')
    }
  })
  
  //  法律声明
  $('#legalNotices').sideNav({
    edge: 'bottom',
    closeOnClick: true,
    duration: inD,
    durationO: outD,
  })
  $('#slide-legal-notices').hover(() => {
  }, () => {
    $('#legalNotices').sideNav('hide')
  })
  $('#legalNoticesM').sideNav({
    edge: 'bottom',
    closeOnClick: true,
    duration: inD,
    durationO: outD,
    onOpen: () => {
      $('#sideMenu').sideNav('hide')
    }
  })
  
  //  PC 端右侧分享
  // let direction = 'right'
  // if(window.$g2_config.is_rtl = true) {
  //   direction = 'left'
  // }
  let direction = window.gp2_is_rtl == true ? 'left' : 'right'
  $('#pcSideShare').sideNav({
    edge: direction,
    duration: inD,
    durationO: outD,
  })
  
  $('#pcSlideShare').hover(() => {
  }, () => {
    $('#pcSideShare').sideNav('hide')
  })
  
  $('#backTop').click(() => {
    $.fn.fullpage.moveTo(1)
  })
}

export { menu, sideNavF }